var TipoNotificacaoEnum = {
    NOTIFICACAO: {
        enumName: 'NOTIFICACAO',
        index: 0,
        name: 'Notificação'
    },
    PUSH_NOTIFICATION: {
        enumName: 'PUSH_NOTIFICATION',  
        index: 1,
        name: 'Push Notification'      
    },
    AMBOS: {
        enumName: 'AMBOS',  
        index: 2,
        name: 'Ambos'      
    },
    get(value) {        
        if(value === null)
            return TipoNotificacaoEnum.AMBOS;

        var array = Object.values(TipoNotificacaoEnum);
        var tipoNotificacaoEnumFound = {};

        array.forEach(element => {
            if(element.enumName === value) {
                tipoNotificacaoEnumFound = element;      
                return ;          
            }            
        });   
        
        return tipoNotificacaoEnumFound;
    },
    getOptions() {        
        var array = Object.values(TipoNotificacaoEnum);
        var tipoNotificacaoEnumList = [];

        tipoNotificacaoEnumList.push({
            status: undefined,
            valor: 0, 
            texto: 'Selecione',
            selected: true
        })

        array.forEach(element => {
            if((typeof element) === 'function') {
                return ;
            }            

            tipoNotificacaoEnumList.push({
                status: element,
                valor: element.name, 
                texto: element.name,
                selected: false
            });            
        });   
        
        return tipoNotificacaoEnumList;
    }
}

export default TipoNotificacaoEnum;